import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { ServicePageLayout } from '../components/layout/ServicePageLayout';
import { services } from '../data/mock';

export const ServicePage = () => {
  const { id } = useParams<{ id: string }>();
  const service = services.find(s => s.path.endsWith(id || ''));

  if (!service) {
    return <Navigate to="/usluge" replace />;
  }

  return <ServicePageLayout service={service} />;
};
